module.exports = __webpack_public_path__ + "img/close-modal-alt.0d50d892.svg";